<div style="display: flex; padding-top: 10px;">
    <app-labeled-slider style="width: calc( 100% - 20px )" [value]="task?.maxPRsBunchSize"
        [maxValue]="maxPRsBunchSizeAllowed" [disabled]="isSpinnerVisible" (valueChanged)="valueChanged($event)"
        title="Property Records Bunch Size:">
    </app-labeled-slider>
    <app-process-small-spinner style="padding-top: 32px" [isVisible]="isSpinnerVisible">
    </app-process-small-spinner>
</div>
